<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div>

            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基本信息" name="info">
                    <component  :is="infoVue" ></component>
                </el-tab-pane>
                <el-tab-pane label="照片&图纸" name="photo">
                    <component  :is="photoVue" ></component>
                </el-tab-pane>
                <!--<el-tab-pane label="视频监控" name="video">-->
                    <!--<StoreInfo/>-->
                <!--</el-tab-pane>-->
                <el-tab-pane label="店员列表" name="clerk">
                    <component  :is="clerkVue" ></component>
                </el-tab-pane>
                <el-tab-pane label="考勤班次" name="shift">
                    <component  :is="shiftVue" ></component>
                </el-tab-pane>
                <el-tab-pane label="销售指标" name="sales">
                    <component  :is="salesVue" ></component>
                </el-tab-pane>
            </el-tabs>

        </div>

    </div>
</template>

<script>
    import StoreInfo from './storesInfo/index.vue'
    import Photos from './photos/index.vue'
    import Clerk from './clerk/index.vue'
    import Attendance from './attendance/index.vue'
    import SalesTarget from './salesTarget/index.vue'
    import {bus} from '../../router/index.js'

    export default {
        data() {
            return {
                loading: false,
                activeName: 'info',
                infoVue:'',
                clerkVue:'',
                photoVue:'',
                shiftVue:'',
                salesVue:''
            }
        },
        created() {
            bus.$emit('type', "info")
            this.infoVue = StoreInfo
        },
        components: {
            StoreInfo,
            Photos,
            Clerk,
            Attendance,
            SalesTarget
        },
        computed: {

        },
        methods: {
            // tab切换
            handleClick(tab) {

                if (tab.name === "info") {
                    bus.$emit('type', "info")
                    this.infoVue = StoreInfo
                } else if(tab.name === "photo"){
                    bus.$emit('type', "photo")
                    this.photoVue = Photos
                }else if(tab.name === "clerk"){
                    bus.$emit('type', "clerk")
                    this.clerkVue = Clerk
                }else if(tab.name === "shift"){
                    bus.$emit('type', "shift")
                    this.shiftVue = Attendance
                }else if(tab.name === "sales"){
                    bus.$emit('type', "sales")
                    this.salesVue = SalesTarget
                }

            }
        }
    }
</script>
<style lang="scss" module>
    .container {

    }
</style>



// WEBPACK FOOTER //
// src/pages/stores/indexSecond.vue